import { DataService } from "@/services/data";
import { handle_error, handle_success } from "@/utils/wretch";
import { RouteObject } from "react-router-dom";

const notificationLoader = async ({ params }: { params: Record<string, string | undefined> }) => {
    try {
        const notification = await DataService.client.get(`/users/notifications/${params.notificationId}/`).json();
        return handle_success(notification);
    } catch (e) {
        return handle_error(e);
    }
};

const NotificationsRoute: RouteObject = {
    path: "notifications",
    children: [
        {
            index: true,
            async lazy() {
                let { NotificationsPage } = await import("@/pages/notifications");
                return { Component: NotificationsPage };
            },
            loader: async ({ request }) => {
                const url = new URL(request.url);
                if (!url.searchParams.has("registration_type")) {
                    url.searchParams.set("registration_type", "PreConfiguredRegistration");
                }
                if (!url.searchParams.has("page_size")) {
                    url.searchParams.set("page_size", "25");
                }
                const notifications = await DataService.client
                    .get(`/users/notifications/${url.searchParams ? "?" + url.searchParams.toString() : ""}`)
                    .json();
                const notification_summary = await DataService.client.get("/users/notifications/summary/").json();
                return { notifications, notification_summary };
            }
        },
        {
            path: ":notificationId",
            async lazy() {
                let { NotificationDetailPage } = await import("@/pages/notification-detail");
                return { Component: NotificationDetailPage };
            },
            loader: notificationLoader
        }
    ]
};
export default NotificationsRoute;
